const CheckFilterValues = {
  methods: {
    checkFiltersValues(queries) {
      const { province, city, transactionDate } = queries;

      return province && city && transactionDate;
    },
    checkSearchValues(queries) {
      const { address, addressId } = queries;

      return !!address && !!addressId;
    },
  },
};

export default CheckFilterValues;
